<template>
  <nav class="menu" :class="{ show: showMenu }">
    <div class="menu-inner">

      <div class="nav-group nav-group--top">
        <router-link
          v-for="page in topPages"
          :key="page.id"
          :to="pathName(page.url)"
          v-html="page.title"
          @click="showMenu = 0"
        />
      </div>

      <p class="menu-tagline" v-if="tagline" v-html="tagline" />

      <div class="nav-group nav-group--bottom">
        <router-link
          v-for="page in bottomPages"
          :key="page.id"
          :to="pathName(page.url)"
          v-html="page.title"
          @click="showMenu = 0"
        />
        <LanguageSwitcher class="lang-in-menu" />
      </div>

    </div>
  </nav>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { yamlToArray, pathName, pageFromPath } from '@/utils'
import { composables } from '@/composables'

const kql = useStore()
const { showMenu } = composables()

const SPLIT = 4

const navPages = computed(() => {
  const uids = yamlToArray(kql.site?.navigation)
  return uids.map(uid => pageFromPath(uid, kql.pages)).filter(Boolean)
})

const topPages    = computed(() => navPages.value.slice(0, SPLIT))
const bottomPages = computed(() => navPages.value.slice(SPLIT))
const tagline     = computed(() => kql.site?.tagline)
</script>

<style scoped>
nav.menu {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  padding: 0 var(--offset);
  background: var(--bg);
  opacity: 0;
  pointer-events: none;
  transition: opacity 350ms ease;
  z-index: 100;
}

nav.menu.show {
  opacity: 1;
  pointer-events: all;
}

.menu-inner {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.nav-group {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

a {
  font-family: var(--serif);
  font-size: clamp(36px, 5.5vw, 80px);
  line-height: 1.05;
  letter-spacing: -0.015em;
  transition: opacity 150ms;
}

a:hover         { opacity: 0.35; }
a.router-link-active { opacity: 0.35; }

.menu-tagline {
  font-family: var(--sans);
  font-size: clamp(12px, 1.1vw, 16px);
  line-height: 1.5;
  max-width: 36em;
  opacity: 0.4;
  margin: 0;
  letter-spacing: 0.01em;
}

.lang-in-menu {
  margin-top: 1.5rem;
}

@media (max-width: 768px) {
  a { font-size: clamp(28px, 8vw, 48px); }
}
</style>
